import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { TwcPopoverComponent } from '@topcon/twc-angular';

/**
 * This directive tries to solve the problem with focus on popovers with toolbar,
 * and closes the popover when clicking outside of the component content
 */
@Directive({
    selector: 'twc-popover[cwPopoverFocusOutClose]',
    standalone: true,
})
export class TwcPopoverFocusCloseDirective implements AfterViewInit, OnDestroy {
    private listener: (e: MouseEvent) => void = (e: MouseEvent): void => this.onClick(e);
    private onDestroy$ = new Subject<void>();
    constructor(
        private el: ElementRef,
        private popover: TwcPopoverComponent
    ) {}

    ngAfterViewInit(): void {
        if (!this.popover) {
            return;
        }

        this.popover.onTrigger.pipe(takeUntil(this.onDestroy$)).subscribe((triggered) => {
            if (triggered) {
                document.addEventListener('click', this.listener);
            } else {
                document.removeEventListener('click', this.listener);
            }
        });
    }

    ngOnDestroy(): void {
        document.removeEventListener('click', this.listener);
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    private onClick(event: MouseEvent): void {
        if (!this.tooltipElement) {
            return;
        }

        const focusedElement = event.target as HTMLElement;

        const isPopoverChild = this.tooltipElement?.contains(focusedElement);
        const isSelectMenu = focusedElement?.closest('div.twc-select-menu');

        if (!isPopoverChild && !isSelectMenu) {
            this.close();
        }
    }

    private close(): void {
        this.popover.close();
        this.popover.hide();
    }

    private get tooltipElement(): HTMLElement {
        return (this.popover as any).tooltipElement;
    }
}
